import { render } from "./home.vue?vue&type=template&id=75800088"
const script = {}
script.render = render

export default script